import jfetch from '@jontetz/jfetch';

jfetch.defaults.headers['Content-Type'] = 'application/json';